// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCzG8nuoLnJBSmIyteCweHhb-NVfYSLoXM",
  authDomain: "interview-7ceca.firebaseapp.com",
  projectId: "interview-7ceca",
  storageBucket: "interview-7ceca.firebasestorage.app",
  messagingSenderId: "110849089136",
  appId: "1:110849089136:web:5f9196f3a615a3033fdeb5",
  measurementId: "G-LEF86QHRKD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);